// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

::ng-deep .cig-parent-wrapper {
  /*--------owl carousel ------------*/
  /* clearfix */
  /* display none until init */
  /* mouse grab icon */
  /* fix */
  /* Styling Next and Prev buttons */
  /* Clickable class fix problem with hover on touch devices */
  /* Use it for non-touch hover action */
  /* Styling Pagination*/
  /* If PaginationNumbers is true */
  /* preloading images */
  /* Style-for-interpretive-short*/
  /* dynamic-style-update*/
  /* DAshboard-Map-Style-update*/
  /* feedback-large-icon*/
}
::ng-deep .cig-parent-wrapper #nav {
  position: relative;
  z-index: 5000;
  text-align: center;
  background: rgba(0, 0, 0, 0.6);
  max-width: 920px;
  margin: 0 auto;
  width: 100%;
}
::ng-deep .cig-parent-wrapper #nav #prevtBtn, ::ng-deep .cig-parent-wrapper #nav #nextBtn {
  cursor: pointer;
}
::ng-deep .cig-parent-wrapper .feedback-slider {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  flex-direction: column-reverse;
  display: flex;
  margin-top: -100px;
  min-height: 685px;
}
::ng-deep .cig-parent-wrapper #Dots {
  position: absolute;
  z-index: 5000;
  bottom: 12px;
  left: 50%;
  transform: translate(-50%, 0%);
  background: rgba(0, 0, 0, 0.1);
  z-index: 99999;
  max-width: 855px;
}
::ng-deep .cig-parent-wrapper .Dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: relative;
  float: left;
  background-color: #fff;
  opacity: 1;
  margin: 5px;
  margin-bottom: 0px;
  cursor: pointer;
  border: 2px solid rgba(255, 255, 255, 0.7);
  background-color: #666;
  border: 2px solid rgba(0, 0, 0, 0.7);
}
::ng-deep .cig-parent-wrapper .Dot:first-child {
  background-color: rgba(0, 0, 0, 0.5) !important;
  border-color: rgba(0, 0, 0, 0.5) !important;
}
::ng-deep .cig-parent-wrapper #prevtBtn, ::ng-deep .cig-parent-wrapper #nextBtn {
  /*color: #666767;*/
  color: #fff;
  font-size: 33px;
  margin: 0px;
  position: relative;
}
::ng-deep .cig-parent-wrapper #prevtBtn {
  float: left;
}
::ng-deep .cig-parent-wrapper #nextBtn {
  float: right;
}
::ng-deep .cig-parent-wrapper .feedback {
  width: 100%;
  height: auto;
  font-size: 40px;
  /*position: absolute;
  /*color: white;*/
  /*top:15%;
  bottom:70px;
  left:0px;*/
}
::ng-deep .cig-parent-wrapper #owl-demo {
  max-width: 980px;
  width: 100%;
  margin: 0 auto;
  -ms-box-shadow: 0px 0px 39px -5px #676a6c;
  box-shadow: 0px 0px 39px -5px #676a6c;
}
::ng-deep .cig-parent-wrapper #owl-demo .item {
  display: block;
  width: 100%;
  min-height: 515px;
}
::ng-deep .cig-parent-wrapper #owl-demo .item .feedback-wrapper {
  display: block;
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
}
::ng-deep .cig-parent-wrapper .owl-carousel .owl-wrapper:after {
  content: ".";
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
}
::ng-deep .cig-parent-wrapper .owl-carousel {
  display: none;
  position: relative;
  width: 100%;
  -ms-touch-action: pan-y;
}
::ng-deep .cig-parent-wrapper .owl-carousel .owl-wrapper {
  display: none;
  position: relative;
  -webkit-transform: translate3d(0px, 0px, 0px);
}
::ng-deep .cig-parent-wrapper .owl-carousel .owl-wrapper-outer {
  overflow: hidden;
  position: relative;
  width: 100%;
}
::ng-deep .cig-parent-wrapper .owl-carousel .owl-wrapper-outer.autoHeight {
  transition: height 500ms ease-in-out;
}
::ng-deep .cig-parent-wrapper .owl-carousel .owl-item {
  float: left;
}
::ng-deep .cig-parent-wrapper .owl-controls .owl-page,
::ng-deep .cig-parent-wrapper .owl-controls .owl-buttons div {
  cursor: pointer;
}
::ng-deep .cig-parent-wrapper .owl-controls {
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
::ng-deep .cig-parent-wrapper .grabbing {
  cursor: url(https://cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/grabbing.png) 8 8, move;
}
::ng-deep .cig-parent-wrapper .owl-carousel .owl-wrapper,
::ng-deep .cig-parent-wrapper .owl-carousel .owl-item {
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls {
  margin-top: -20px;
  text-align: center;
  position: relative;
  z-index: 999999;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-pagination {
    display: none !important;
  }
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-buttons div {
  position: relative;
  display: inline-block;
  zoom: 1;
  display: inline; /*IE7 life-saver */
  margin: 5px 2px;
  overflow: hidden;
  width: 40px;
  height: 45px;
  line-height: 45px;
  font-size: 0px;
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-buttons div:before {
  font-size: 40px;
  font-family: "FontAwesome";
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  filter: Alpha(Opacity=70); /*IE7 fix*/
  opacity: 0.7;
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-buttons div.owl-prev:before {
  content: "\\f137";
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-buttons div.owl-next:before {
  content: "\\f138";
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls.clickable .owl-buttons div:hover:before {
  filter: Alpha(Opacity=100); /*IE7 fix*/
  opacity: 1;
  text-decoration: none;
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-page {
  display: inline-block;
  zoom: 1;
  display: inline; /*IE7 life-saver */
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-page span {
  display: block;
  width: 8px;
  height: 8px;
  margin: 4px;
  border-radius: 20px;
  background: #6c6c6c !important;
  filter: Alpha(Opacity=50); /*IE7 fix*/
  opacity: 0.5;
}
@media (max-width: 860px) {
  ::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-page span {
    margin: 4px 3px;
  }
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-page.active span,
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls.clickable .owl-page:hover span {
  background-color: #3b3937 !important;
  filter: Alpha(Opacity=100); /*IE7 fix*/
  opacity: 1;
}
::ng-deep .cig-parent-wrapper .owl-buttons {
  position: absolute;
  right: 15px;
  top: -40px;
}
::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-page span.owl-numbers {
  height: auto;
  width: auto;
  color: #fff;
  padding: 2px 10px;
  font-size: 12px;
  border-radius: 30px;
}
::ng-deep .cig-parent-wrapper .owl-item.loading {
  min-height: 150px;
  background: url(https://cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/AjaxLoader.gif) no-repeat center center;
}
@media (max-width: 767px) {
  ::ng-deep .cig-parent-wrapper #owl-demo .item {
    min-height: 475px;
  }
  ::ng-deep .cig-parent-wrapper .owl-theme .owl-controls {
    margin-top: 0px;
  }
  ::ng-deep .cig-parent-wrapper .owl-buttons {
    position: relative;
    top: inherit;
    right: inherit;
  }
  ::ng-deep .cig-parent-wrapper .owl-theme .owl-controls .owl-page span {
    margin: 2px;
  }
}
::ng-deep .cig-parent-wrapper .feedback-page .wrapper-content {
  max-height: 80vh;
  overflow: auto;
}
::ng-deep .cig-parent-wrapper #feed-banner {
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: center center !important;
}
::ng-deep .cig-parent-wrapper #feed-banner .title {
  color: #fff;
}
::ng-deep .cig-parent-wrapper #great-mind {
  background-repeat: no-repeat !important;
  background-size: cover !important;
}
::ng-deep .cig-parent-wrapper #great-mind .title-sm {
  color: #fff;
}
::ng-deep .cig-parent-wrapper #think {
  background-repeat: no-repeat !important;
  background-color: #fff !important;
  background-size: contain !important;
  background-position: left 62% !important;
}
::ng-deep .cig-parent-wrapper #f-bulb {
  background-repeat: no-repeat !important;
  background-color: #bfbfbf !important;
  background-size: initial !important;
  background-position: center center !important;
}
::ng-deep .cig-parent-wrapper #f-bulb .title {
  position: absolute;
  top: 50%;
  text-align: center;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  line-height: 60px;
}
::ng-deep .cig-parent-wrapper #f-now {
  background-repeat: no-repeat !important;
  background-size: cover !important;
}
::ng-deep .cig-parent-wrapper #f-now .title-sm {
  color: #fff;
  float: left;
  background: rgba(243, 243, 243, 0.3) !important;
  min-width: 200px;
  padding: 10px;
}
::ng-deep .cig-parent-wrapper #f-end {
  background-repeat: no-repeat !important;
  background-size: cover !important;
}
::ng-deep .cig-parent-wrapper #f-end .feedback-content img {
  margin: 20px 0;
}
::ng-deep .cig-parent-wrapper #congo .feedback-content img {
  margin: 0 0 20px;
}
::ng-deep .cig-parent-wrapper #f4-stage .title-sm {
  margin-bottom: 30px;
}
::ng-deep .cig-parent-wrapper .f-sight {
  margin-top: 45px;
}
::ng-deep .cig-parent-wrapper .f-score .col-xs-5 {
  margin-top: 28px;
}
::ng-deep .cig-parent-wrapper .s-icon .fa {
  margin: 5px;
  cursor: pointer;
}
::ng-deep .cig-parent-wrapper #f-fit .feedback-content img {
  max-width: 450px;
}
::ng-deep .cig-parent-wrapper .feedback-player {
  width: calc(100% - 65px);
  float: right;
  padding: 5px;
}
::ng-deep .cig-parent-wrapper .feedback-content {
  padding: 50px 50px 0;
}
::ng-deep .cig-parent-wrapper .feedback-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(243, 243, 243, 0.8) !important;
  padding: 5px 5px 32px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .cig-parent-wrapper .feedback-footer {
    padding: 5px;
  }
}
@media (max-width: 767px) {
  ::ng-deep .cig-parent-wrapper .feedback-footer .feed-logo {
    display: none;
  }
}
::ng-deep .cig-parent-wrapper .feedback-footer audio {
  width: calc(100% - 335px) !important;
  margin-bottom: -3px;
  backface-visibility: hidden;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .cig-parent-wrapper .feedback-footer audio {
    width: calc(100% - 205px) !important;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .cig-parent-wrapper .feedback-footer audio {
    width: calc(100% - 175px) !important;
  }
}
@media only screen and (max-width: 575px) {
  ::ng-deep .cig-parent-wrapper .feedback-footer audio {
    width: calc(100% - 60px) !important;
  }
}
::ng-deep .cig-parent-wrapper .feedback-footer .author-logo {
  float: left;
}
::ng-deep .cig-parent-wrapper .feedback .feedback-wrapper {
  top: 50% !important;
}
::ng-deep .cig-parent-wrapper .feedback audio::-webkit-media-controls-panel {
  background: transparent;
}
::ng-deep .cig-parent-wrapper .feedback audio::-moz-media-controls-panel {
  background: transparent;
}
::ng-deep .cig-parent-wrapper .feedback audio::-webkit-media-controls-current-time-display, ::ng-deep .cig-parent-wrapper .feedback audio::-webkit-media-controls-time-remaining-display {
  color: #676a6c;
}
::ng-deep .cig-parent-wrapper .feedback audio::-webkit-media-controls-volume-slider, ::ng-deep .cig-parent-wrapper .feedback audio::-webkit-media-controls-mute-button, ::ng-deep .cig-parent-wrapper .feedback audio::-webkit-media-controls-volume-slider-container {
  display: none;
}
::ng-deep .cig-parent-wrapper div#Dots {
  /*background: rgba(0,0,0,.4);*/
  text-align: left;
  width: 100%;
  display: block;
  bottom: 74px;
  padding: 0px;
  padding-left: 8%;
  background: transparent;
  /*max-width:920px;*/
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  transform: none;
}
::ng-deep .cig-parent-wrapper div#Dots .Dot {
  display: inline-block;
  float: none !important;
  background-color: #fff;
  border-color: #fff;
}
::ng-deep .cig-parent-wrapper #nav {
  left: 0px;
  right: 0px;
  position: absolute !important;
  bottom: 90px !important;
  background: transparent !important;
  max-width: 980px !important;
}
::ng-deep .cig-parent-wrapper #prevtBtn {
  float: right !important;
  margin-right: 60px !important;
  color: #6c6c6c !important;
  bottom: 0px;
  right: 0;
  position: absolute !important;
  font-size: 40px !important;
}
::ng-deep .cig-parent-wrapper #nextBtn {
  color: #6c6c6c !important;
  position: absolute !important;
  font-size: 40px !important;
  right: 20px;
  bottom: 0;
}
::ng-deep .cig-parent-wrapper .cig_collab_img img {
  max-height: 300px;
}
@media only screen and (max-width: 599px) {
  ::ng-deep .cig-parent-wrapper .feedback p {
    font-size: 15px;
  }
}
::ng-deep .cig-parent-wrapper .feedback .right-label-text .eq-developer {
  padding: 7px;
  color: #fff;
  font-size: 16px;
}
::ng-deep .cig-parent-wrapper .feedback .fix-label {
  background: #6d6e71;
  color: #fff;
  font-size: 28px;
  padding: 7px;
  font-family: "Museo-700";
  display: inline-block;
  vertical-align: top;
}
::ng-deep .cig-parent-wrapper .feedback .about-u {
  background: #f1f1f2;
  overflow: hidden;
  margin-bottom: 10px;
}
::ng-deep .cig-parent-wrapper .feedback .about-u .right-label {
  display: block;
  margin-bottom: 10px;
  text-align: right;
}
::ng-deep .cig-parent-wrapper .feedback-test_result {
  max-width: 400px;
  margin: 0px auto;
  text-align: center;
}
@media only screen and (max-height: 414px) and (orientation: landscape) {
  ::ng-deep .cig-parent-wrapper .feedback-test_result {
    transform: scale(0.8);
    margin-top: -15px;
  }
}
::ng-deep .cig-parent-wrapper .feedback-test_result .big-profile {
  display: inline-block;
}
::ng-deep .cig-parent-wrapper .feedback-test_result p {
  display: inline-block;
  background: #6d6e71;
  color: #fff;
  padding: 7px;
  margin: 0;
  vertical-align: super;
  font-family: "Museo-700";
}
::ng-deep .cig-parent-wrapper .test-last .title-sm {
  font-size: 26px;
}
::ng-deep .cig-parent-wrapper .test-last p {
  font-size: 12px;
  margin-bottom: 0px;
  color: #666;
}
::ng-deep .cig-parent-wrapper .product-box {
  padding: 0;
  border: none;
  box-shadow: 10px 10px 10px -3px #676a6c;
}
::ng-deep .cig-parent-wrapper .product-box:hover, ::ng-deep .cig-parent-wrapper .product-box:active {
  border: none;
  box-shadow: 3px 3px 7px 0px #a8a8a8;
}
::ng-deep .cig-parent-wrapper .dashboard-wrapper .car-big-heading img {
  max-width: 325px !important;
}
::ng-deep .cig-parent-wrapper .practioner-dash-wrap {
  margin-top: 0px;
}
::ng-deep .cig-parent-wrapper .icon-btn {
  position: absolute;
  bottom: 5px;
  font-size: 22px;
  color: #676a6c;
  margin: auto;
  left: 0;
  right: 0;
  display: inline-block;
}
::ng-deep .cig-parent-wrapper .icon-btn:hover {
  color: #48ac51;
}
::ng-deep .cig-parent-wrapper .fs-logo-feedback {
  max-width: 350px;
  margin: 30px auto 0;
}
::ng-deep .cig-parent-wrapper #f-implement1 .profile-description {
  font-size: 15px;
}
@media (max-width: 960px) {
  ::ng-deep .cig-parent-wrapper #f-implement1 .profile-description {
    max-height: 245px;
    overflow: hidden;
    overflow-y: auto;
  }
}
@media (max-width: 767px) {
  ::ng-deep .cig-parent-wrapper #f-implement1 .profile-description {
    font-size: 12px;
    max-height: 310px;
  }
  body.mini-navbar ::ng-deep .cig-parent-wrapper #f-implement1 .profile-description {
    max-height: 302px;
  }
}
@media (max-width: 414px) {
  ::ng-deep .cig-parent-wrapper #f-implement1 .profile-description {
    max-height: 250px;
  }
}
@media only screen and (max-height: 414px) and (orientation: landscape) {
  ::ng-deep .cig-parent-wrapper #f-implement1 .profile-description {
    max-height: 115px !important;
    font-size: 13px !important;
  }
}
::ng-deep .cig-parent-wrapper #f-implement1 .fix-label {
  font-size: 23px;
}
@media (max-width: 767px) {
  ::ng-deep .cig-parent-wrapper #f-implement1 .fix-label {
    font-size: 16px;
    float: left;
  }
}
::ng-deep .cig-parent-wrapper #f-implement1 .about-u {
  padding: 10px;
}
@media (max-width: 767px) {
  ::ng-deep .cig-parent-wrapper #f-implement1 .about-u {
    margin-bottom: 5px;
  }
  ::ng-deep .cig-parent-wrapper #f-implement1 .about-u .right-label-text {
    font-size: 16px;
    margin-bottom: 0px;
    display: inline-block;
    vertical-align: top;
    padding: 7px;
    float: right;
  }
}
::ng-deep .cig-parent-wrapper #f-implement1 .right-label-text {
  font-size: 18px;
  color: #fff;
}
::ng-deep .cig-parent-wrapper #f-implement1 .right-label-text span {
  padding: 8px;
}
@media (max-width: 992px) {
  ::ng-deep .cig-parent-wrapper #f-implement1 .right-label-text span {
    padding: 3px;
    font-size: 14px;
  }
}
::ng-deep .cig-parent-wrapper .big-profile .profile_types {
  background: url("https://assets.foursightonline.com/app/images/foursight-profile-types-lg.png") !important;
  width: 160px;
  height: 80px;
}
::ng-deep .cig-parent-wrapper .big-profile .developer {
  background-position: -680px -84px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .accelerator {
  background-position: -170px 0 !important;
}
::ng-deep .cig-parent-wrapper .big-profile .analyst {
  background-position: 0 -174px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .clarifier {
  background-position: -345px -174px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .driver {
  background-position: -334px 0 !important;
}
::ng-deep .cig-parent-wrapper .big-profile .early-bird {
  background-position: -338px -84px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .finisher {
  background-position: -676px 0 !important;
}
::ng-deep .cig-parent-wrapper .big-profile .hare {
  background-position: -512px -174px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .idea-broker {
  background-position: -506px 0 !important;
}
::ng-deep .cig-parent-wrapper .big-profile .ideator {
  background-position: 0 -84px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .implementer {
  background-position: -170px -84px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .integrator {
  background-position: -680px -196px !important;
  margin-top: 0px;
  height: 40px;
}
::ng-deep .cig-parent-wrapper .big-profile .optimist {
  background-position: -172px -174px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .realist {
  background-position: -508px -84px !important;
}
::ng-deep .cig-parent-wrapper .big-profile .theorist {
  background-position: 0 0 !important;
}
::ng-deep .cig-parent-wrapper video::-internal-media-controls-download-button, ::ng-deep .cig-parent-wrapper audio::-internal-media-controls-download-button {
  display: none;
}
::ng-deep .cig-parent-wrapper video::-webkit-media-controls-enclosure, ::ng-deep .cig-parent-wrapper audio::-webkit-media-controls-enclosure {
  overflow: hidden;
}
::ng-deep .cig-parent-wrapper video::-webkit-media-controls-panel, ::ng-deep .cig-parent-wrapper audio::-webkit-media-controls-panel {
  width: calc(100% + 30px); /* Adjust as needed */
}
::ng-deep .cig-parent-wrapper .interactive-guide {
  overflow: hidden;
}
::ng-deep .cig-parent-wrapper .interactive-guide .feedback {
  box-shadow: 0px 0px 39px -5px #676a6c;
  margin: 0px !important;
}
::ng-deep .cig-parent-wrapper .flipbook {
  width: 100% !important;
  margin-top: 60px;
}
::ng-deep .cig-parent-wrapper .flipbook .page-wrapper {
  margin: 0 auto !important;
}
::ng-deep .cig-parent-wrapper .flipbook-viewport {
  overflow: hidden;
  width: 100%;
  height: 100%;
}
::ng-deep .cig-parent-wrapper .flipbook-viewport .container {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: auto;
}
::ng-deep .cig-parent-wrapper .flipbook-viewport .flipbook {
  width: 922px;
  height: 600px;
  left: -461px;
  top: -300px;
}
::ng-deep .cig-parent-wrapper .flipbook-viewport .page {
  width: 461px;
  height: 600px;
  background-color: white;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
::ng-deep .cig-parent-wrapper .flipbook-viewport .shadow {
  -webkit-transition: -webkit-box-shadow 0.5s;
  -moz-transition: -moz-box-shadow 0.5s;
  -o-transition: -webkit-box-shadow 0.5s;
  -ms-transition: -ms-box-shadow 0.5s;
  -o-box-shadow: 0 0 20px #ccc;
  -ms-box-shadow: 0 0 20px #ccc;
  box-shadow: 0 0 20px #ccc;
}
::ng-deep .cig-parent-wrapper .flipbook .page {
  -ms-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  -o-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}
::ng-deep .cig-parent-wrapper .flipbook .page img {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  margin: 0;
  max-width: 100%;
}
::ng-deep .cig-parent-wrapper .flipbook .feedback-footer audio {
  vertical-align: bottom;
  margin-top: 12px;
  margin-bottom: 0px;
}
::ng-deep .cig-parent-wrapper .flipbook .f-score .col-xs-7 img {
  width: 100%;
}
::ng-deep .cig-parent-wrapper .flipbook #f-implement img {
  max-width: 100%;
}
::ng-deep .cig-parent-wrapper .flipbook .feedback-footer audio {
  width: calc(100% - 165px);
  min-width: 0px;
}
::ng-deep .cig-parent-wrapper .flipbook #f-zone .feedback-content p {
  margin-top: 25%;
}
::ng-deep .cig-parent-wrapper .flipbook #congo .title-sm {
  margin-top: 15%;
}
::ng-deep .cig-parent-wrapper .flipbook #f-implement .title-sm {
  margin-bottom: 12%;
}
::ng-deep .cig-parent-wrapper .flipbook .feedback .custom-col {
  width: 23%;
  margin: 1%;
}
::ng-deep .cig-parent-wrapper .flip-control {
  text-align: center;
}
::ng-deep .cig-parent-wrapper .flip-control a {
  display: inline-block;
  margin: 0px 5px;
}
@media only screen and (min-width: 1000px) and (max-width: 1200px) {
  ::ng-deep .cig-parent-wrapper .flipbook .col-xs-7, ::ng-deep .cig-parent-wrapper .flipbook .col-xs-5 {
    width: 100%;
  }
  ::ng-deep .cig-parent-wrapper .flipbook .title-sm {
    font-size: 26px !important;
  }
  ::ng-deep .cig-parent-wrapper .flipbook .feedback .title {
    font-size: 40px;
    line-height: 42px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .cig-parent-wrapper .flipbook .title-sm {
    font-size: 26px !important;
  }
  ::ng-deep .cig-parent-wrapper .flipbook .feedback .title {
    font-size: 40px;
    line-height: 42px;
  }
}
@media only screen and (max-width: 420px) {
  ::ng-deep .cig-parent-wrapper .flipbook .col-xs-7, ::ng-deep .cig-parent-wrapper .flipbook .col-xs-5 {
    width: 100%;
  }
  ::ng-deep .cig-parent-wrapper .flipbook .feedback .custom-col {
    width: 48%;
    margin: 1%;
  }
  ::ng-deep .cig-parent-wrapper .flipbook #think {
    background-size: inherit !important;
    background-position-y: 50% !important;
  }
  ::ng-deep .cig-parent-wrapper .flipbook #f-profile .title-sm {
    margin-bottom: 28%;
  }
}
::ng-deep .cig-parent-wrapper .circled-preference {
  border: 2px solid;
  border-radius: 65% 65%;
  padding: 20px 0px;
}

/* full-screen-style */
#full-screen {
  margin-left: 15px;
  margin-right: 15px;
}

a#exit-screen {
  display: none;
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 18px;
  color: #6c6c6c;
}

@media only screen and (max-width: 767px) and (orientation: portrait) {
  ::ng-deep body.full-screen {
    overflow: hidden;
    position: fixed;
  }
}
::ng-deep body.full-screen .feedback-page {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  background: #fff;
  left: 0;
  margin-top: 0px;
  padding: 0px;
}
@media only screen and (max-height: 414px) and (orientation: landscape) {
  ::ng-deep body.full-screen .feedback-page {
    position: absolute;
    overflow: hidden;
  }
}
::ng-deep body.full-screen .feedback-slider {
  margin: 0px;
}
::ng-deep body.full-screen a#exit-screen {
  display: block;
  z-index: 99;
}
::ng-deep body.full-screen .feedback {
  max-width: 100%;
  top: 0;
  bottom: 0;
}
::ng-deep body.full-screen .custom-row {
  overflow: hidden;
  width: 100%;
}
::ng-deep body.full-screen .owl-carousel .feedback-content .f-sight img, ::ng-deep body.full-screen .owl-carousel .feedback-content .f-score img {
  max-width: 150px;
  width: 100%;
}
@media only screen and (max-height: 414px) and (orientation: landscape) {
  ::ng-deep body.full-screen .owl-carousel .feedback-content .f-sight img, ::ng-deep body.full-screen .owl-carousel .feedback-content .f-score img {
    max-width: 115px;
  }
}

::ng-deep body.full-screen #owl-demo {
  width: 90%;
  margin-top: 35px;
}

@media only screen and (min-width: 768px) {
  ::ng-deep body.full-screen #owl-demo {
    margin-top: 60px;
  }
}
@media only screen and (max-height: 736px) and (orientation: portrait) {
  ::ng-deep body.full-screen #owl-demo {
    /*width: 90%;*/
    margin-top: 40px;
  }
}
@media only screen and (max-height: 414px) and (orientation: landscape) {
  ::ng-deep body.full-screen #owl-demo {
    margin-top: 40px;
    /*width: 100%;
    margin-top: 0px;
    -webkit-transform: scale(0.61);
    -moz-transform: scale(0.61);
    -ms-transform: scale(0.61);
    -o-transform: scale(0.61);
    transform: scale(0.61);
    position: relative;
    top: -70px;
    margin-left: -75px;
    width:90%;*/
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep body.full-screen .feedback ul li {
    font-size: 20px;
  }
  ::ng-deep body.full-screen .feedback .custom-col p {
    font-size: 16px;
  }
  ::ng-deep body.full-screen a#exit-screen {
    font-size: 16px;
  }
  ::ng-deep body.full-screen .feedback p {
    font-size: 16px;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback ul li {
    font-size: 16px;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback p {
    font-size: 16px;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback .custom-col {
    float: none;
  }
  ::ng-deep body.full-screen .owl-carousel #f-bulb {
    background-size: contain !important;
  }
}
::ng-deep .work-well-slide h3 {
  font-size: 22px;
}
::ng-deep .work-well-slide .title-sm {
  margin-bottom: 50px !important;
}
@media (max-width: 767px) {
  ::ng-deep .work-well-slide .title-sm {
    margin-bottom: 25px !important;
  }
}
::ng-deep .work-well-slide .disabled {
  height: 50px;
  vertical-align: middle;
  margin-top: 35px;
  font-size: 28px;
}
@media (max-width: 767px) {
  ::ng-deep .work-well-slide .disabled {
    margin: 0px;
  }
}

@media (min-width: 680px) {
  .new-dashboard .col-sm-3 {
    max-width: 180px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .feedback-page .col-xs-7, ::ng-deep .feedback-page .col-xs-5 {
    width: 100%;
  }
  ::ng-deep .feedback-page .feedback-content {
    padding: 20px 20px 0;
  }
  ::ng-deep .feedback-page #prevtBtn, ::ng-deep .feedback-page #nextBtn {
    font-size: 25px !important;
    bottom: 8px;
  }
  ::ng-deep .feedback-page #prevtBtn {
    margin-right: 30px !important;
  }
  ::ng-deep .feedback-page #nextBtn {
    right: 4px;
  }
  ::ng-deep .feedback-page div#Dots {
    padding-left: 16%;
  }
  ::ng-deep .feedback-page div#Dots .Dot {
    width: 5px;
    height: 5px;
    margin: 3px;
  }
  ::ng-deep .feedback-page a#exit-screen {
    top: 5px;
    right: 5px;
  }
}
@media only screen and (max-height: 414px) and (orientation: landscape) {
  ::ng-deep .feedback-page .col-xs-7 {
    width: 50% !important;
  }
  ::ng-deep .feedback-page .col-xs-5 {
    width: 50% !important;
  }
  ::ng-deep .work-well-slide .center-block {
    text-align: center;
  }
  ::ng-deep .work-well-slide .col-sm-2, .work-well-slide .col-sm-5 {
    display: inline-block;
    vertical-align: middle;
    width: 25%;
  }
  ::ng-deep body.full-screen {
    width: 100%;
    overflow: hidden;
  }
  ::ng-deep body.full-screen #owl-demo .item {
    min-height: 260px !important;
  }
  ::ng-deep body.full-screen #owl-demo #think.item {
    background-size: 60% auto !important;
    background-position: center center !important;
  }
  ::ng-deep body.full-screen #page-wrapper {
    min-height: 414px;
  }
  ::ng-deep body.full-screen .feedback p {
    font-size: 12px !important;
  }
  ::ng-deep body.full-screen .owl-carousel .title {
    font-size: 25px !important;
    line-height: 1.1 !important;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback .title-sm {
    font-size: 15px !important;
    margin-bottom: 5px;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback .f-sight {
    margin-top: 15px;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback ul li {
    font-size: 14px !important;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback p {
    font-size: 14px !important;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback .custom-col {
    width: 15%;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback .feedback-footer {
    max-height: 40px;
    padding: 0px 5px;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback .feedback-footer .author-logo {
    max-width: 40px;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback .feedback-footer .feedback-player {
    padding: 0px 5px;
    max-height: 40px;
  }
  ::ng-deep body.full-screen .owl-carousel .feedback .feedback-footer .feedback-player audio {
    height: 40px;
    margin-bottom: 0px;
  }
  ::ng-deep body.full-screen .owl-carousel #f-profile #chartarea {
    transform: scale(0.58);
    margin-top: -40px;
    width: 100%;
  }
  ::ng-deep body.full-screen .owl-carousel #clar-result #chartarea,
  ::ng-deep body.full-screen .owl-carousel #w-ideat-result #chartarea,
  ::ng-deep body.full-screen .owl-carousel #w-develop-result #chartarea,
  ::ng-deep body.full-screen .owl-carousel #w-impl-result #chartarea {
    transform: scale(0.9);
  }
  ::ng-deep body.full-screen .owl-carousel #f-implement img {
    max-width: 200px;
  }
}
::ng-deep .feedback-page img {
  max-width: 100%;
}
::ng-deep .feedback-page .feedback .custom-col {
  width: 23%;
  margin: 1%;
}
@media (max-width: 767px) {
  ::ng-deep .feedback-page .feedback .custom-col {
    width: 20%;
    max-width: 122px !important;
    display: inline-block;
    float: none;
  }
}
@media (max-width: 599px) {
  ::ng-deep .feedback-page .feedback .custom-col {
    width: 33%;
    max-width: 105px !important;
  }
  ::ng-deep body.mini-navbar ::ng-deep .feedback-page .feedback .custom-col {
    width: 39%;
  }
}
@media (max-width: 767px) {
  ::ng-deep .feedback-page .feedback .custom-row {
    margin: 0 auto;
    display: inline-block;
    text-align: center;
    width: 100%;
  }
  ::ng-deep .feedback-page .feedback .custom-col:nth-child(3) {
    clear: both;
  }
}
::ng-deep .feedback-page .c-profile img {
  max-width: 300px;
}

::ng-deep .feedback {
  max-width: 980px;
  margin: auto;
  right: 0;
  text-align: left !important;
  font-family: "Museo-300";
  background: #fff;
}
::ng-deep .feedback .title {
  font-size: 60px;
  margin: 0px;
  font-weight: 600;
  font-family: "Museo-700";
}
::ng-deep .feedback .title-sm {
  font-size: 40px;
  margin: 0px 0 10px;
  font-weight: 600;
  font-family: "Museo-300";
}
@media (max-width: 991px) {
  ::ng-deep .feedback .title-sm {
    font-size: 30px;
  }
}
@media (max-width: 800px) {
  ::ng-deep .feedback .title-sm {
    font-size: 27px;
  }
}
::ng-deep .feedback .custom-col {
  float: left;
  margin: 10px;
}
::ng-deep .feedback p {
  font-size: 18px;
}
::ng-deep .feedback ul {
  padding: 0 0 0 22px;
  margin: 0px;
}
::ng-deep .feedback ul li {
  font-size: 18px;
}
@media (max-width: 767px) {
  ::ng-deep .feedback ul li {
    font-size: 15px;
  }
  body.mini-navbar ::ng-deep .feedback ul li {
    font-size: 14px;
  }
}

@media only screen and (max-width: 767px) {
  ::ng-deep .feedback-page .title-sm {
    font-size: 20px !important;
    margin-bottom: 25px;
  }
  ::ng-deep .feedback-page .feedback .title {
    font-size: 40px;
    line-height: 42px !important;
  }
  body.full-screen .owl-carousel .feedback .title-sm {
    font-size: 20px !important;
  }
  body.full-screen .owl-carousel .title {
    font-size: 40px;
    line-height: 42px !important;
  }
}
@media only screen and (max-height: 736px) and (orientation: portrait) {
  body.full-screen #owl-demo .item {
    min-height: 430px;
  }
  body.full-screen .owl-carousel .feedback .title-sm {
    margin-bottom: 10px !important;
    font-size: 18px !important;
  }
  body.full-screen .owl-carousel .feedback .custom-col {
    max-width: 98px !important;
  }
  body.full-screen .owl-carousel .feedback .title {
    font-size: 35px !important;
    line-height: 1.1 !important;
  }
  body.full-screen .owl-carousel .feedback ul li {
    font-size: 14px !important;
  }
  body.full-screen .owl-carousel .feedback p {
    font-size: 14px !important;
    margin-bottom: 0px;
  }
  body.full-screen .owl-carousel .feedback .fs-logo-feedback img {
    max-width: 250px;
  }
  body.full-screen .owl-carousel .feedback .center-block {
    transform: scale(0.8);
    margin-top: -15px;
  }
  body.full-screen .owl-carousel #f-implement1 .profile-description {
    max-height: 255px;
  }
}
@media print {
  @page {
    size: letter landscape;
  }
  body {
    width: 100%;
    height: 100%;
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    max-height: 100%;
    max-width: 100%;
  }
  ::ng-deep body {
    width: 100% !important;
  }
  ::ng-deephtml {
    width: 100% !important;
  }
  ::ng-deepbody.fs-skin #wrapper {
    overflow: visible !important;
  }
  ::ng-deep .cig-parent-wrapper #owl-demo {
    max-width: 100% !important;
  }
  ::ng-deep .cig-parent-wrapper .owl-carousel .owl-wrapper-outer {
    overflow: visible !important;
  }
  ::ng-deep .cig-parent-wrapper .owl-item {
    float: none !important;
    width: 100% !important;
    min-height: 100% !important;
    clear: both;
    page-break-before: always !important;
    display: block !important;
    transform: translateY(20%) !important;
  }
  ::ng-deep .cig-parent-wrapper .owl-carousel .owl-wrapper {
    page-break-inside: always !important;
    float: none !important;
  }
  ::ng-deep .cig-parent-wrapper .owl-carousel .owl-wrapper, ::ng-deep .cig-parent-wrapper .owl-carousel .owl-item {
    width: 100% !important;
    white-space: normal !important;
    visibility: visible !important;
    opacity: 1 !important;
    float: none !important;
  }
  ::ng-deep .cig-parent-wrapper #feed-banner {
    background-image: url("https://assets.foursightonline.com/app/images/feed-banner.png") !important;
  }
  ::ng-deep .cig-parent-wrapper #great-mind {
    background-image: url("https://assets.foursightonline.com/app/images/2nd-page.png") !important;
  }
  ::ng-deep .cig-parent-wrapper #think {
    background-image: url("https://assets.foursightonline.com/app/images/think-pref.png") !important;
  }
  ::ng-deep .cig-parent-wrapper #f-bulb {
    background-image: url("https://assets.foursightonline.com/app/images/feed-bulb.png") !important;
  }
  ::ng-deep .cig-parent-wrapper #f-now {
    background-image: url("https://assets.foursightonline.com/app/images/f-now.png") !important;
  }
  ::ng-deep .cig-parent-wrapper #f-end {
    background-image: url("https://assets.foursightonline.com/app/images/f-end.png") !important;
  }
  ::ng-deep .cig-parent-wrapper .feedback-footer {
    display: none !important;
  }
  ::ng-deep .cig-parent-wrapper .owl-controls {
    display: none !important;
  }
  ::ng-deep body.fs-skin #hubspot-messages-iframe-container.widget-align-right {
    display: none !important;
  }
}
::ng-deep.translate-btn {
  position: absolute;
  bottom: 18px;
  right: 11%;
}

::ng-deep.translate-text {
  font-size: 16px !important;
  max-width: 980px;
  margin: 20px auto 0 auto;
}
::ng-deep.translate-text .well {
  max-height: 180px;
  overflow-y: auto;
}

::ng-deep.feedback-player {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

::ng-deep.cig-parent-wrapper .owl-buttons {
  position: absolute;
  right: 15px;
  top: auto;
  bottom: 35px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.cig-parent-wrapper .owl-buttons {
    bottom: -13px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.cig-parent-wrapper .owl-buttons {
    bottom: 3px;
  }
}
@media only screen and (max-width: 575px) {
  ::ng-deep.cig-parent-wrapper .owl-buttons {
    position: static;
  }
}

::ng-deep.translate-btn {
  position: absolute;
  bottom: 55px;
  right: 110px;
  background: transparent !important;
  border: transparent !important;
  color: #6c6c6c !important;
}
::ng-deep.translate-btn:active {
  box-shadow: none !important;
}
::ng-deep.translate-btn i::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.translate-btn {
    bottom: 29px;
  }
}
@media only screen and (max-width: 575px) {
  ::ng-deep.translate-btn {
    right: 10px;
  }
}

::ng-deep.translate-btn.translate-btn2 {
  right: 158px;
}

@media only screen and (max-width: 991px) {
  ::ng-deep.feedback-footer audio + img + img {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/cig/cig.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA5YA;EA0FE,oCAAA;EA6BA,aAAA;EASF,4BAAA;EAyCA,oBAAA;EAKA,QAAA;EAuBA,kCAAA;EAiCA,4DAAA;EACA,sCAAA;EAOA,sBAAA;EAqCA,iCAAA;EAaA,sBAAA;EAwBA,gCAAA;EAqRA,wBAAA;EAwEA,8BAAA;EAkHA,uBAAA;AAzWA;AA7ZA;EACI,kBAAA;EACA,aAAA;EACA,kBAAA;EAEA,8BAAA;EAEA,gBAAA;EACA,cAAA;EACA,WAAA;AA6ZJ;AA1ZE;EACE,eAAA;AA4ZJ;AAzZE;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EAEA,8BAAA;EACA,aAAA;EACA,kBAAA;EAEA,iBAAA;AAyZJ;AAtZE;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;EACA,8BAAA;EAEA,8BAAA;EAEA,cAAA;EACA,gBAAA;AAsZJ;AAnZE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,sBDoBe;ECnBf,UAAA;EACA,WAAA;EAAY,kBAAA;EACZ,eAAA;EACA,0CAAA;EACA,sBAAA;EACA,oCAAA;AAsZJ;AAnZE;EACE,+CAAA;EACA,2CAAA;AAqZJ;AAlZE;EACE,kBAAA;EACA,WDIe;ECHf,eAAA;EACA,WAAA;EACA,kBAAA;AAoZJ;AAjZE;EACE,WAAA;AAmZJ;AAhZE;EACE,YAAA;AAkZJ;AA/YE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA;kBAAA;EAEA;;YAAA;AAmZJ;AA7YE;EACE,gBAAA;EACA,WAAA;EACA,cAAA;EAEA,yCAAA;EAEA,qCAAA;AA+YJ;AA3YE;EACE,cAAA;EACA,WAAA;EACA,iBAAA;AA6YJ;AA3YE;EACE,cAAA;EACA,kBAAA;EAGA,gCAAA;EACA,SAAA;EAAU,QAAA;EACV,WAAA;EACA,YAAA;AA8YJ;AAzYA;EACE,YAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;AA2YF;AAxYA;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;AA0YF;AAxYA;EACE,aAAA;EACA,kBAAA;EACA,6CAAA;AA0YF;AAxYA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;AA0YF;AAxYA;EAKE,oCAAA;AA0YF;AAvYA;EACE,WAAA;AAyYF;AAvYA;;EAEE,eAAA;AAyYF;AAvYA;EACE,yBAAA;EAIA,iBAAA;EACA,6CAAA;AAyYF;AArYA;EACI,6FAAA;AAuYJ;AAnYA;;EAEE,mCAAA;EACA,gCAAA;EACA,+BAAA;EACA,uCAAA;EACA,oCAAA;EACA,mCAAA;AAqYF;AAlYA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAoYF;AAnYE;EACE;IACE,wBAAA;EAqYJ;AACF;AA/XA;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,eAAA,EAAA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAiYF;AA/XA;EACE,eAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA,EAAA,UAAA;EACA,YAAA;AAiYF;AA9XA;EACE,gBAAA;AAgYF;AA9XA;EACE,gBAAA;AAgYF;AA5XA;EACE,0BAAA,EAAA,UAAA;EACA,UAAA;EACA,qBAAA;AA8XF;AAzXA;EACE,qBAAA;EACA,OAAA;EACA,eAAA,EAAA,kBAAA;AA2XF;AAzXA;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EAGA,mBAAA;EACA,8BAAA;EACA,yBAAA,EAAA,UAAA;EACA,YAAA;AA2XF;AAzXE;EAZF;IAaI,eAAA;EA4XF;AACF;AAzXA;;EAEE,oCAAA;EACA,0BAAA,EAAA,UAAA;EACA,UAAA;AA2XF;AAxXA;EACI,kBAAA;EACA,WAAA;EACA,UAAA;AA0XJ;AArXA;EACE,YAAA;EACA,WAAA;EACA,WDnNiB;ECoNjB,iBAAA;EACA,eAAA;EAGA,mBAAA;AAuXF;AAnXA;EACE,iBAAA;EACA,iHAAA;AAqXF;AAlXA;EACE;IACE,iBAAA;EAoXF;EAlXA;IACE,eAAA;EAoXF;EAlXA;IACE,kBAAA;IACA,YAAA;IACA,cAAA;EAoXF;EAlXA;IACE,WAAA;EAoXF;AACF;AA3WE;EACE,gBAAA;EACA,cAAA;AA6WJ;AAzWA;EACE,uCAAA;EACA,iCAAA;EACA,6CAAA;AA2WF;AAzWE;EACE,WDpQe;AC+mBnB;AAxWA;EACE,uCAAA;EACA,iCAAA;AA0WF;AAxWE;EACE,WD5Qe;ACsnBnB;AAtWA;EACE,uCAAA;EACA,iCAAA;EACA,mCAAA;EACA,wCAAA;AAwWF;AArWA;EACE,uCAAA;EACA,oCAAA;EACA,mCAAA;EACA,6CAAA;AAuWF;AArWE;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EAGA,2BAAA;EACA,iBAAA;AAuWJ;AAnWA;EACE,uCAAA;EACA,iCAAA;AAqWF;AAnWE;EACE,WD/Se;ECgTf,WAAA;EACA,+CAAA;EACA,gBAAA;EACA,aAAA;AAqWJ;AAjWA;EACE,uCAAA;EACA,iCAAA;AAmWF;AA/VI;EACE,cAAA;AAiWN;AAxVI;EACE,gBAAA;AA0VN;AAnVE;EACE,mBAAA;AAqVJ;AAhVA;EACE,gBAAA;AAkVF;AA7UE;EACE,gBAAA;AA+UJ;AA1UE;EACE,WAAA;EACA,eAAA;AA4UJ;AApUI;EACE,gBAAA;AAsUN;AAjUA;EACE,wBAAA;EACA,YAAA;EACA,YAAA;AAmUF;AAhUA;EACE,oBAAA;AAkUF;AA/TA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,+CAAA;EACA,qBAAA;AAiUF;AA/TE;EARF;IASI,YAAA;EAkUF;AACF;AAzTI;EAPF;IAQI,aAAA;EA4TJ;AACF;AAxTE;EACE,oCAAA;EACA,mBAAA;EAGA,2BAAA;AA0TJ;AAxTI;EAPF;IAQE,oCAAA;EA2TF;AACF;AAzTE;EAXA;IAYE,oCAAA;EA4TF;AACF;AA1TG;EAfD;IAgBE,mCAAA;EA6TF;AACF;AAtTE;EACE,WAAA;AAwTJ;AAnTE;EACE,mBAAA;AAqTJ;AAlTE;EACE,uBAAA;AAoTJ;AAjTE;EACE,uBAAA;AAmTJ;AAjTE;EACE,cDleiB;ACqxBrB;AAjTE;EACE,aAAA;AAmTJ;AA/SA;EAEE,8BAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AAgTF;AA9SE;EACE,qBAAA;EACA,sBAAA;EACA,sBDzde;EC0df,kBD1de;AC0wBnB;AA7SA;EACE,SAAA;EACA,UAAA;EACA,6BAAA;EACA,uBAAA;EACA,kCAAA;EACA,2BAAA;AA+SF;AA5SA;EACE,uBAAA;EACA,6BAAA;EACA,yBAAA;EACA,WAAA;EACA,QAAA;EACA,6BAAA;EACA,0BAAA;AA8SF;AA3SA;EACE,yBAAA;EACA,6BAAA;EACA,0BAAA;EACA,WAAA;EACA,SAAA;AA6SF;AAzSE;EACE,iBAAA;AA2SJ;AAnSA;EACI;IACE,eAAA;EAqSJ;AACF;AA/RE;EACE,YAAA;EACA,WD7gBe;EC8gBf,eAAA;AAiSJ;AA9RE;EACE,mBDjjBiB;ECkjBjB,WDnhBe;ECohBf,eAAA;EACA,YAAA;EACA,wBDxlBO;ECylBP,qBAAA;EACA,mBAAA;AAgSJ;AA7RE;EACE,mBDxjBkB;ECyjBlB,gBAAA;EACA,mBAAA;AA+RJ;AA7RI;EACE,cAAA;EACA,mBAAA;EACA,iBAAA;AA+RN;AA1RA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AA4RF;AA1RE;EALF;IAUI,qBAAA;IACA,iBAAA;EA6RF;AACF;AA3RE;EACE,qBAAA;AA6RJ;AA1RE;EACE,qBAAA;EACA,mBD3lBiB;EC4lBjB,WD7jBe;EC8jBf,YAAA;EACA,SAAA;EACA,qBAAA;EACA,wBDnoBO;AC+5BX;AAvRE;EACE,eAAA;AAyRJ;AAvRE;EACE,eAAA;EACA,kBAAA;EACA,WAAA;AAyRJ;AApRA;EACE,UAAA;EACA,YAAA;EACA,uCAAA;AAsRF;AApRE;EACE,YAAA;EACA,mCAAA;AAsRJ;AAlRA;EACE,2BAAA;AAoRF;AAjRA;EACE,eAAA;AAmRF;AAhRA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,cD5oBmB;EC6oBnB,YAAA;EACA,OAAA;EACA,QAAA;EACA,qBAAA;AAkRF;AAhRE;EACE,cAAA;AAkRJ;AA9QA;EACE,gBAAA;EACA,mBAAA;AAgRF;AA5QE;EACE,eAAA;AA8QJ;AA5QI;EAHF;IAII,iBAAA;IACA,gBAAA;IACA,gBAAA;EA+QJ;AACF;AA7QI;EATF;IAUI,eAAA;IACA,iBAAA;EAgRJ;EA9QI;IACE,iBAAA;EAgRN;AACF;AA7QI;EAlBF;IAmBM,iBAAA;EAgRN;AACF;AA9QI;EAtBF;IAuBI,4BAAA;IACA,0BAAA;EAiRJ;AACF;AA9QE;EACE,eAAA;AAgRJ;AA/QI;EAFF;IAGI,eAAA;IACA,WAAA;EAkRJ;AACF;AA/QE;EACE,aAAA;AAiRJ;AA/QI;EAHF;IAII,kBAAA;EAkRJ;EAhRI;IACI,eAAA;IACA,kBAAA;IACA,qBAAA;IACA,mBAAA;IACA,YAAA;IAEA,YAAA;EAiRR;AACF;AA7QE;EACE,eAAA;EACA,WDjrBe;ACg8BnB;AA7QI;EACE,YAAA;AA+QN;AA7QM;EAHF;IAII,YAAA;IACA,eAAA;EAgRN;AACF;AAnQE;EACE,0GAAA;EACA,YAAA;EACA,YAAA;AAqQJ;AAlQE;EACE,4CAAA;AAoQJ;AAlQE;EACE,wCAAA;AAoQJ;AAlQE;EACE,wCAAA;AAoQJ;AAlQE;EACE,6CAAA;AAoQJ;AAlQE;EACE,wCAAA;AAoQJ;AAlQE;EACE,4CAAA;AAoQJ;AAlQE;EACE,wCAAA;AAoQJ;AAlQE;EACE,6CAAA;AAoQJ;AAlQE;EACE,wCAAA;AAoQJ;AAlQE;EACE,uCAAA;AAoQJ;AAlQE;EACE,4CAAA;AAoQJ;AAlQE;EACE,6CAAA;EACA,eAAA;EACA,YAAA;AAoQJ;AAlQE;EACE,6CAAA;AAoQJ;AAlQE;EACE,4CAAA;AAoQJ;AAlQE;EACE,mCAAA;AAoQJ;AAhQA;EACE,aAAA;AAkQF;AA/PA;EACE,gBAAA;AAiQF;AA9PA;EACE,wBAAA,EAAA,qBAAA;AAgQF;AA7PA;EACE,gBAAA;AA+PF;AA7PE;EACE,qCAAA;EACA,sBAAA;AA+PJ;AA3PA;EACE,sBAAA;EACA,gBAAA;AA6PF;AA3PE;EACE,yBAAA;AA6PJ;AA1PE;EACE,gBAAA;EACA,WAAA;EACA,YAAA;AA4PJ;AA1PI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AA4PN;AAzPI;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AA2PN;AAxPI;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,4BAAA;EACA,0BAAA;AA0PN;AAvPI;EACE,2CAAA;EACA,qCAAA;EACA,sCAAA;EACA,mCAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;AAyPN;AArPE;EACE,2CAAA;EACA,0CAAA;EACA,uCAAA;AAuPJ;AArPI;EACE,2BAAA;EACA,yBAAA;EAGA,iBAAA;EACA,SAAA;EACA,eAAA;AAuPN;AAnPE;EACE,sBAAA;EACA,gBAAA;EACA,kBAAA;AAqPJ;AAlPE;EACE,WAAA;AAoPJ;AAjPE;EACE,eAAA;AAmPJ;AAhPE;EACE,yBAAA;EACA,cAAA;AAkPJ;AA/OE;EACE,eAAA;AAiPJ;AA9OE;EACE,eAAA;AAgPJ;AA9OE;EACE,kBAAA;AAgPJ;AA9OE;EACE,UAAA;EACA,UAAA;AAgPJ;AA5OA;EACE,kBAAA;AA8OF;AA5OE;EACE,qBAAA;EACA,eAAA;AA8OJ;AA1OA;EAII;IACE,WAAA;EAyOJ;EAtOE;IACE,0BAAA;EAwOJ;EArOE;IACE,eAAA;IACA,iBAAA;EAuOJ;AACF;AAnOA;EAII;IACE,0BAAA;EAkOJ;EA/NE;IACE,eAAA;IACA,iBAAA;EAiOJ;AACF;AA7NA;EAII;IACE,WAAA;EA4NJ;EAzNE;IACE,UAAA;IACA,UAAA;EA2NJ;EAxNE;IACE,mCAAA;IACA,qCAAA;EA0NJ;EArNI;IACE,kBAAA;EAuNN;AACF;AAnNA;EACE,iBAAA;EACA,sBAAA;EACA,iBAAA;AAqNF;;AA/MA,sBAAA;AAEA;EACE,iBAAA;EACA,kBAAA;AAiNF;;AA9MA;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAiNF;;AA5ME;EAFF;IAGI,gBAAA;IACA,eAAA;EAgNF;AACF;AA9ME;EACE,eAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBD99Be;EC+9Bf,OAAA;EACA,eAAA;EACA,YAAA;AAgNJ;AA9MI;EAXF;IAYI,kBAAA;IACA,gBAAA;EAiNJ;AACF;AA7ME;EACE,WAAA;AA+MJ;AA7ME;EACE,cAAA;EACA,WAAA;AA+MJ;AA5ME;EACE,eAAA;EACA,MAAA;EACA,SAAA;AA8MJ;AAhLE;EACE,gBAAA;EACA,WAAA;AAkLJ;AAjHQ;EACE,gBAAA;EACA,WAAA;AAmHV;AAjHU;EAJF;IAKI,gBAAA;EAoHV;AACF;;AArGE;EACE,UAAA;EACA,gBAAA;AAwGJ;;AArGE;EACE;IACE,gBAAA;EAwGJ;AACF;AArGE;EACE;IACE,cAAA;IACA,gBAAA;EAuGJ;AACF;AApGE;EACE;IACE,gBAAA;IACA;;;;;;;;;;eAAA;EAgHJ;AACF;AAnGE;EAEE;IACE,eAAA;EAoGJ;EAjGE;IACE,eAAA;EAmGJ;EAjGE;IACE,eAAA;EAmGJ;EAjGE;IACE,eAAA;EAmGJ;EA/FM;IACE,eAAA;EAiGR;EA/FM;IACE,eAAA;EAiGR;EA/FM;IACE,WAAA;EAiGR;EA9FI;IACE,mCAAA;EAgGN;AACF;AA1FE;EACE,eAAA;AA4FJ;AAzFE;EACE,8BAAA;AA2FJ;AAzFI;EAHF;IAII,8BAAA;EA4FJ;AACF;AAxFE;EACE,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AA0FJ;AAxFI;EANF;IAOI,WAAA;EA2FJ;AACF;;AAtFA;EACE;IACE,gBAAA;EAyFF;AACF;AAtFA;EAGI;IACE,WAAA;EAsFJ;EAnFE;IACE,oBAAA;EAqFJ;EAlFE;IACE,0BAAA;IACA,WAAA;EAoFJ;EAjFE;IACE,6BAAA;EAmFJ;EAhFE;IACE,UAAA;EAkFJ;EA3EE;IACE,iBAAA;EA6EJ;EA3EI;IACE,UAAA;IACA,WAAA;IACA,WAAA;EA6EN;EAzEE;IACE,QAAA;IACA,UAAA;EA2EJ;AACF;AArEA;EAEI;IACE,qBAAA;EAsEJ;EApEE;IACE,qBAAA;EAsEJ;EAlEA;IACE,kBAAA;EAoEF;EAjEA;IACE,qBAAA;IACA,sBAAA;IACA,UAAA;EAmEF;EAhEA;IACE,WAAA;IACA,gBAAA;EAkEF;EAhEE;IACE,4BAAA;EAkEJ;EA/DE;IACE,oCAAA;IACA,6CAAA;EAiEJ;EA9DE;IACE,iBAAA;EAgEJ;EA7DE;IACE,0BAAA;EA+DJ;EA3DI;IACE,0BAAA;IACA,2BAAA;EA6DN;EAzDM;IACE,0BAAA;IACA,kBAAA;EA2DR;EAxDM;IACE,gBAAA;EA0DR;EAvDM;IACE,0BAAA;EAyDR;EAvDM;IACE,0BAAA;EAyDR;EAtDM;IACE,UAAA;EAwDR;EArDM;IACE,gBAAA;IACA,gBAAA;EAuDR;EArDQ;IACE,eAAA;EAuDV;EApDQ;IACE,gBAAA;IACA,gBAAA;EAsDV;EApDU;IACE,YAAA;IACA,kBAAA;EAsDZ;EAhDI;IAKE,sBAAA;IACA,iBAAA;IACA,WAAA;EAkDN;EA/CI;;;;IAQE,qBAAA;EAiDN;EA7CM;IACE,gBAAA;EA+CR;AACF;AAxCI;EACE,eAAA;AA0CN;AAvCI;EACE,UAAA;EACA,UAAA;AAyCN;AAvCM;EAJF;IAKI,UAAA;IACA,2BAAA;IACA,qBAAA;IACA,WAAA;EA0CN;AACF;AAxCM;EAXF;IAYI,UAAA;IACA,2BAAA;EA2CN;EAzCM;IACE,UAAA;EA2CR;AACF;AAtCM;EACE;IACE,cAAA;IACA,qBAAA;IACA,kBAAA;IACA,WAAA;EAwCR;EArCQ;IACE,WAAA;EAuCV;AACF;AAlCI;EACE,gBAAA;AAoCN;;AA/BA;EACE,gBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,wBDh/CS;ECi/CT,gBD56CiB;AC88CnB;AAhCE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,wBDp/CO;ACshDX;AA/BE;EACE,eAAA;EAUA,kBAAA;EACA,gBAAA;EACA,wBDvgDO;AC+hDX;AAlCI;EAHF;IAIM,eAAA;EAqCN;AACF;AAnCI;EAPF;IAQM,eAAA;EAsCN;AACF;AA/BE;EACE,WAAA;EACA,YAAA;AAiCJ;AA9BE;EACE,eAAA;AAgCJ;AA7BE;EACE,mBAAA;EACA,WAAA;AA+BJ;AA7BI;EAEE,eAAA;AA8BN;AA5BM;EAJF;IAKI,eAAA;EA+BN;EA7BM;IACE,eAAA;EA+BR;AACF;;AAxBA;EAII;IACE,0BAAA;IACA,mBAAA;EAwBJ;EArBE;IACE,eAAA;IACA,4BAAA;EAuBJ;EAhBI;IACE,0BAAA;EAkBN;EAhBI;IACE,eAAA;IACA,4BAAA;EAkBN;AACF;AAbA;EAGM;IACE,iBAAA;EAaN;EAPM;IACE,8BAAA;IACA,0BAAA;EASR;EAPM;IACE,0BAAA;EASR;EAPM;IACE,0BAAA;IACA,2BAAA;EASR;EAPM;IACE,0BAAA;EASR;EAPM;IACE,0BAAA;IACA,kBAAA;EASR;EALQ;IACE,gBAAA;EAOV;EAJM;IAKE,qBAAA;IACA,iBAAA;EAMR;EAHI;IACE,iBAAA;EAKN;AACF;AACA;EAEE;IAAO,sBAAA;EACP;EAAA;IAAK,WAAA;IACH,YAAA;IACA,iCAAA;IACA,8BAAA;IACA,gBAAA;IACA,eAAA;EAGF;EAAA;IACI,sBAAA;EAEJ;EACA;IACI,sBAAA;EACJ;EAEA;IACE,4BAAA;EAAF;EAIE;IACE,0BAAA;EAFJ;EAKE;IACE,4BAAA;EAHJ;EAKE;IACE,sBAAA;IACA,sBAAA;IACA,2BAAA;IAEA,WAAA;IACA,oCAAA;IAEA,yBAAA;IACA,qCAAA;EALJ;EAOE;IACE,oCAAA;IACA,sBAAA;EALJ;EAOE;IACE,sBAAA;IACA,8BAAA;IACA,8BAAA;IACA,qBAAA;IACA,sBAAA;EALJ;EAOE;IACE,iGAAA;EALJ;EAOE;IACE,8FAAA;EALJ;EAOE;IACE,gGAAA;EALJ;EAOE;IACE,+FAAA;EALJ;EAOE;IACE,2FAAA;EALJ;EAOE;IACE,2FAAA;EALJ;EAOE;IACE,wBAAA;EALJ;EAOE;IACE,wBAAA;EALJ;EASA;IACE,wBAAA;EAPF;AACF;AAWA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;AATJ;;AAWA;EACE,0BAAA;EACA,gBAAA;EACA,wBAAA;AARF;AASE;EACE,iBAAA;EACA,gBAAA;AAPJ;;AAaA;EAGE,aAAA;EAEA,eAAA;EAGA,mBAAA;AAVF;;AAcE;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;AAXN;AAYM;EALJ;IAMM,aAAA;EATN;AACF;AAUM;EARJ;IASM,WAAA;EAPN;AACF;AAQM;EAXJ;IAYM,gBAAA;EALN;AACF;;AASA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kCAAA;EACA,8BAAA;EACA,yBAAA;AANJ;AAOI;EACE,2BAAA;AALN;AAOI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AALN;AAQI;EApBJ;IAqBM,YAAA;EALJ;AACF;AAMI;EAvBJ;IAwBM,WAAA;EAHJ;AACF;;AAQA;EACI,YAAA;AALJ;;AAWM;EAFJ;IAGM,aAAA;EAPN;AACF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","// Font\n@import './../../../assets/styles/variables';\n\n::ng-deep .cig-parent-wrapper{\n#nav{\n    position: relative;\n    z-index:5000;\n    text-align: center;\n\n    background: rgba(0, 0, 0, 0.6);\n\n    max-width: 920px;\n    margin: 0 auto;\n    width: 100%;\n  }\n\n  #nav #prevtBtn, #nav #nextBtn{\n    cursor: pointer;\n  }\n\n  .feedback-slider{\n    overflow: hidden;\n    position: relative;\n    width: 100%;\n    height: 100%;\n\n    flex-direction: column-reverse;\n    display: flex;\n    margin-top: -100px;\n\n    min-height: 685px;\n  }\n\n  #Dots{\n    position: absolute;\n    z-index:5000;\n    bottom: 12px;\n    left:50%;\n    transform:translate(-50%,0%);\n\n    background: rgba(0, 0, 0, 0.1);\n\n    z-index: 99999;\n    max-width: 855px;\n  }\n\n  .Dot{\n    width:8px;\n    height: 8px;\n    border-radius: 50%;\n    position: relative;\n    float: left;\n    background-color: $color-light-type;\n    opacity:1;\n    margin:5px; margin-bottom:0px;\n    cursor: pointer;\n    border:2px solid rgba(255,255,255,0.7);\n    background-color: #666;\n    border: 2px solid rgba(0,0,0,0.7);\n  }\n\n  .Dot:first-child{\n    background-color: rgba(0,0,0,.5) !important;\n    border-color: rgba(0,0,0,.5) !important;\n  }\n\n  #prevtBtn,#nextBtn{\n    /*color: #666767;*/\n    color: $color-light-type;\n    font-size: 33px;\n    margin: 0px;\n    position: relative;\n  }\n\n  #prevtBtn{\n    float: left;\n  }\n\n  #nextBtn{\n    float: right;\n  }\n\n  .feedback {\n    width: 100%;\n    height:auto;\n    font-size: 40px;\n    /*position: absolute;\n    /*color: white;*/\n    /*top:15%;\n    bottom:70px;\n    left:0px;*/\n  }\n\n  /*--------owl carousel ------------*/\n  #owl-demo{\n    max-width: 980px;\n    width: 100%;\n    margin: 0 auto;\n    -webkit-box-shadow: 0px 0px 39px -5px $body-content-color;\n    -ms-box-shadow: 0px 0px 39px -5px $body-content-color;\n    -moz-box-shadow: 0px 0px 39px -5px $body-content-color;\n    box-shadow: 0px 0px 39px -5px $body-content-color;\n  }\n  \n\n  #owl-demo .item{\n    display: block;\n    width: 100%;\n    min-height: 515px;\n  }\n  #owl-demo .item .feedback-wrapper{\n    display:block;\n    position:absolute;\n    -webkit-transform:translate(-50%,-50%);\n    -ms-transform:translate(-50%,-50%);\n    transform:translate(-50%,-50%);\n    left:50%; top:50%;\n    width: 100%;\n    height: 100%;\n  }\n\n\n  /* clearfix */\n.owl-carousel .owl-wrapper:after {\n  content: \".\";\n  display: block;\n  clear: both;\n  visibility: hidden;\n  line-height: 0;\n  height: 0;\n}\n/* display none until init */\n.owl-carousel{\n  display: none;\n  position: relative;\n  width: 100%;\n  -ms-touch-action: pan-y;\n}\n.owl-carousel .owl-wrapper{\n  display: none;\n  position: relative;\n  -webkit-transform: translate3d(0px, 0px, 0px);\n}\n.owl-carousel .owl-wrapper-outer{\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n.owl-carousel .owl-wrapper-outer.autoHeight{\n  -webkit-transition: height 500ms ease-in-out;\n  -moz-transition: height 500ms ease-in-out;\n  -ms-transition: height 500ms ease-in-out;\n  -o-transition: height 500ms ease-in-out;\n  transition: height 500ms ease-in-out;\n}\n\n.owl-carousel .owl-item{\n  float: left;\n}\n.owl-controls .owl-page,\n.owl-controls .owl-buttons div{\n  cursor: pointer;\n}\n.owl-controls {\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n/* mouse grab icon */\n.grabbing {\n    cursor:url(https://cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/grabbing.png) 8 8, move;\n}\n\n/* fix */\n.owl-carousel  .owl-wrapper,\n.owl-carousel  .owl-item{\n  -webkit-backface-visibility: hidden;\n  -moz-backface-visibility:    hidden;\n  -ms-backface-visibility:     hidden;\n  -webkit-transform: translate3d(0,0,0);\n  -moz-transform: translate3d(0,0,0);\n  -ms-transform: translate3d(0,0,0);\n}\n\n.owl-theme .owl-controls{\n  margin-top: -20px;\n  text-align: center;\n  position: relative;\n  z-index: 999999;\n  @media only screen and (max-width: 991px) {\n    .owl-pagination {\n      display: none !important;\n    }\n  }\n}\n\n/* Styling Next and Prev buttons */\n\n.owl-theme .owl-controls .owl-buttons div{\n  position: relative;\n  display: inline-block;\n  zoom: 1;\n  display: inline;/*IE7 life-saver */\n  margin: 5px 2px;\n  overflow:hidden;\n  width: 40px;\n  height: 45px;\n  line-height: 45px;\n  font-size: 0px;\n}\n.owl-theme .owl-controls .owl-buttons div:before{\n  font-size: 40px;\n  font-family: \"FontAwesome\";\n  display: inline-block;\n  position: absolute;\n  left:0;\n  top:0;\n  width: 100%;\n  height: 100%;\n  filter: Alpha(Opacity=70);/*IE7 fix*/\n  opacity: 0.7;\n}\n\n.owl-theme .owl-controls .owl-buttons div.owl-prev:before{\n  content: \"\\f137\";\n}\n.owl-theme .owl-controls .owl-buttons div.owl-next:before{\n  content: \"\\f138\";\n}\n/* Clickable class fix problem with hover on touch devices */\n/* Use it for non-touch hover action */\n.owl-theme .owl-controls.clickable .owl-buttons div:hover:before{\n  filter: Alpha(Opacity=100);/*IE7 fix*/\n  opacity: 1;\n  text-decoration: none;\n}\n\n/* Styling Pagination*/\n\n.owl-theme .owl-controls .owl-page{\n  display: inline-block;\n  zoom: 1;\n  display: inline;/*IE7 life-saver */\n}\n.owl-theme .owl-controls .owl-page span{\n  display: block;\n  width: 8px;\n  height: 8px;\n  margin: 4px;\n  -webkit-border-radius: 20px;\n  -moz-border-radius: 20px;\n  border-radius: 20px;\n  background: #6c6c6c !important;\n  filter: Alpha(Opacity=50);/*IE7 fix*/\n  opacity: 0.5;\n\n  @media (max-width:860px){\n    margin: 4px 3px;\n  }\n}\n\n.owl-theme .owl-controls .owl-page.active span,\n.owl-theme .owl-controls.clickable .owl-page:hover span{\n  background-color: #3b3937 !important;\n  filter: Alpha(Opacity=100);/*IE7 fix*/\n  opacity: 1;\n}\n\n.owl-buttons {\n    position: absolute;\n    right: 15px;\n    top: -40px;\n}\n\n/* If PaginationNumbers is true */\n\n.owl-theme .owl-controls .owl-page span.owl-numbers{\n  height: auto;\n  width: auto;\n  color: $color-light-type;\n  padding: 2px 10px;\n  font-size: 12px;\n  -webkit-border-radius: 30px;\n  -moz-border-radius: 30px;\n  border-radius: 30px;\n}\n\n/* preloading images */\n.owl-item.loading{\n  min-height: 150px;\n  background: url(https://cdnjs.cloudflare.com/ajax/libs/owl-carousel/1.3.3/AjaxLoader.gif) no-repeat center center;\n}\n\n@media(max-width:767px){\n  #owl-demo .item{\n    min-height: 475px;\n  }\n  .owl-theme .owl-controls{\n    margin-top: 0px;\n  }\n  .owl-buttons{\n    position: relative;\n    top: inherit;\n    right:inherit;\n  }\n  .owl-theme .owl-controls .owl-page span{\n    margin: 2px;\n  }\n}\n\n// ===========================================================\n/* Style-for-interpretive-short*/\n\n\n.feedback-page {\n\n  .wrapper-content {\n    max-height:80vh;\n    overflow:auto;\n  }\n}\n\n#feed-banner {\n  background-repeat: no-repeat !important;\n  background-size:cover !important;\n  background-position: center center !important;\n\n  .title {\n    color:$color-light-type;\n  }\n}\n#great-mind {\n  background-repeat: no-repeat !important;\n  background-size:cover !important;\n\n  .title-sm {\n    color:$color-light-type;\n  }\n}\n\n#think {\n  background-repeat: no-repeat !important;\n  background-color: $color-light-type !important;\n  background-size:contain !important;\n  background-position:left 62% !important;\n}\n\n#f-bulb {\n  background-repeat: no-repeat !important;\n  background-color: #bfbfbf !important;\n  background-size:initial !important;\n  background-position:center center !important;\n\n  .title {\n    position:absolute;\n    top:50%;\n    text-align: center;\n    left: 0;\n    right: 0;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    line-height: 60px;\n  }\n}\n\n#f-now {\n  background-repeat: no-repeat !important;\n  background-size:cover !important;\n\n  .title-sm {\n    color:$color-light-type;\n    float:left;\n    background: rgba(243,243,243,.3) !important;\n    min-width: 200px;\n    padding:10px;\n  }\n}\n\n#f-end {\n  background-repeat: no-repeat !important;\n  background-size:cover !important;\n\n  .feedback-content{\n\n    img {\n      margin: 20px 0;\n    }\n  }\n}\n\n#congo {\n\n  .feedback-content{\n\n    img {\n      margin: 0 0 20px;\n    }\n  }\n}\n\n#f4-stage {\n\n  .title-sm {\n    margin-bottom:30px;\n  }\n\n}\n\n.f-sight {\n  margin-top:45px;\n}\n\n.f-score {\n\n  .col-xs-5 {\n    margin-top: 28px;\n  }\n}\n.s-icon {\n\n  .fa {\n    margin:5px;\n    cursor: pointer;\n  }\n}\n\n#f-fit {\n\n  .feedback-content {\n\n    img {\n      max-width: 450px;\n    }\n  }\n}\n\n.feedback-player {\n  width: calc(100% - 65px);\n  float: right;\n  padding: 5px;\n}\n\n.feedback-content {\n  padding:50px 50px 0;\n}\n\n.feedback-footer {\n  position:absolute;\n  bottom:0;\n  left:0;\n  right:0;\n  background:rgba(243,243,243,.8) !important;\n  padding:5px 5px 32px;\n\n  @media only screen and (max-width: 991px) {\n    padding: 5px;\n  }\n\n  .feed-logo {\n    & + .feed-logo{\n      //margin-left:-12px;\n\n\n    }\n\n    @media(max-width:767px){\n      display: none;\n    }\n\n  }\n\n  audio {\n    width: calc(100% - 335px) !important;\n    margin-bottom: -3px;\n    -webkit-backface-visibility:hidden;\n    -ms-backface-visibility:hidden;\n    backface-visibility:hidden;\n\n    @media only screen and (max-width: 991px) {\n    width: calc(100% - 205px) !important;\n  }\n\n  @media only screen and (max-width: 767px) {\n    width: calc(100% - 175px) !important;\n  }\n\n   @media only screen and (max-width: 575px) {\n    width: calc(100% - 60px) !important;\n  }\n\n    // @media (max-width:767px){\n    //   width: 100% !important;\n    // }\n  }\n\n  .author-logo {\n    float:left;\n  }\n}\n\n.feedback {\n  .feedback-wrapper {\n    top:50% !important;\n  }\n\n  audio::-webkit-media-controls-panel{\n    background:transparent;\n  }\n\n  audio::-moz-media-controls-panel{\n    background:transparent;\n  }\n  audio::-webkit-media-controls-current-time-display, audio::-webkit-media-controls-time-remaining-display {\n    color:$body-content-color;\n  }\n  audio::-webkit-media-controls-volume-slider , audio::-webkit-media-controls-mute-button,  audio::-webkit-media-controls-volume-slider-container{\n    display: none;\n  }\n}\n\ndiv#Dots {\n  // position: relative;\n  /*background: rgba(0,0,0,.4);*/\n  text-align: left;\n  width: 100%;\n  display: block;\n  bottom: 74px;\n  padding:0px;\n  padding-left:8%;\n  background:transparent;\n  /*max-width:920px;*/\n  position: absolute;\n  left: 0;\n  right:0;\n  margin:0 auto;\n  transform:none;\n\n  .Dot {\n    display: inline-block;\n    float:none !important;\n    background-color:$color-light-type;\n    border-color:$color-light-type;\n  }\n}\n#nav {\n  left:0px;\n  right:0px;\n  position: absolute !important;\n  bottom:90px !important;\n  background:transparent !important;\n  max-width: 980px !important;\n}\n\n#prevtBtn {\n  float: right !important;\n  margin-right: 60px !important;\n  color:#6c6c6c !important;\n  bottom:0px;\n  right:0;\n  position:absolute !important;\n  font-size: 40px !important;\n}\n\n#nextBtn {\n  color:#6c6c6c !important;\n  position:absolute !important;\n  font-size: 40px !important;\n  right: 20px;\n  bottom:0;\n}\n\n.cig_collab_img{\n  img{\n    max-height: 300px;\n  }\n}\n\n\n\n\n\n@media only screen  and (max-width:599px) {\n    .feedback p {\n      font-size: 15px;\n    }\n}\n\n/* dynamic-style-update*/\n.feedback {\n\n  .right-label-text .eq-developer {\n    padding:7px;\n    color:$color-light-type;\n    font-size: 16px;\n  }\n\n  .fix-label {\n    background: $color-neutral-dark;\n    color: $color-light-type;\n    font-size: 28px;\n    padding: 7px;\n    font-family:$muso-700;\n    display: inline-block;\n    vertical-align: top;\n  }\n\n  .about-u {\n    background: $color-neutral-light;\n    overflow: hidden;\n    margin-bottom: 10px;\n\n    .right-label {\n      display: block;\n      margin-bottom: 10px;\n      text-align: right;\n    }\n  }\n}\n\n.feedback-test_result {\n  max-width: 400px;\n  margin:0px auto;\n  text-align: center;\n\n  @media only screen and (max-height: 414px) and (orientation:landscape) {\n    -webkit-transform: scale(0.8);\n    -moz-transform: scale(0.8);\n    -ms-transform: scale(0.8);\n    -o-transform: scale(0.8);\n    transform: scale(0.8);\n    margin-top: -15px;\n  }\n\n  .big-profile {\n    display: inline-block\n  }\n\n  p {\n    display: inline-block;\n    background: $color-neutral-dark;\n    color: $color-light-type;\n    padding: 7px;\n    margin: 0;\n    vertical-align: super;\n    font-family: $muso-700;\n  }\n}\n\n.test-last {\n  .title-sm {\n    font-size: 26px;\n  }\n  p {\n    font-size: 12px;\n    margin-bottom: 0px;\n    color:#666;\n  }\n}\n\n/* DAshboard-Map-Style-update*/\n.product-box {\n  padding: 0;\n  border: none;\n  box-shadow: 10px 10px 10px -3px $body-content-color;\n\n  &:hover , &:active {\n    border: none;\n    box-shadow: 3px 3px 7px 0px #a8a8a8;\n  }\n}\n\n.dashboard-wrapper .car-big-heading img {\n  max-width: 325px !important;\n}\n\n.practioner-dash-wrap {\n  margin-top: 0px;\n}\n\n.icon-btn {\n  position: absolute;\n  bottom: 5px;\n  font-size: 22px;\n  color:$body-content-color;\n  margin:auto;\n  left:0;\n  right:0;\n  display: inline-block;\n\n  &:hover {\n    color:#48ac51;\n  }\n}\n\n.fs-logo-feedback{\n  max-width: 350px;\n  margin: 30px auto 0;\n}\n\n#f-implement1{\n  .profile-description{\n    font-size: 15px;\n\n    @media(max-width:960px){\n      max-height: 245px;\n      overflow: hidden;\n      overflow-y: auto;\n    }\n\n    @media(max-width:767px){\n      font-size: 12px;\n      max-height: 310px;\n\n      body.mini-navbar &{\n        max-height: 302px;\n      }\n    }\n\n    @media(max-width:414px){\n        max-height: 250px;\n    }\n\n    @media only screen and (max-height: 414px) and (orientation:landscape) {\n      max-height: 115px !important;\n      font-size: 13px !important;\n    }\n  }\n\n  .fix-label {\n    font-size: 23px;\n    @media(max-width:767px){\n      font-size: 16px;\n      float: left;\n    }\n  }\n\n  .about-u{\n    padding: 10px;\n\n    @media(max-width:767px){\n      margin-bottom: 5px;\n\n      .right-label-text {\n          font-size: 16px;\n          margin-bottom: 0px;\n          display: inline-block;\n          vertical-align: top;\n          padding: 7px;\n          //background: $clarify-color !important;\n          float: right;\n      }\n    }\n  }\n\n  .right-label-text{\n    font-size: 18px;\n    color: $color-light-type;\n\n    span{\n      padding: 8px;\n\n      @media (max-width:992px){\n        padding:3px;\n        font-size:14px;\n      }\n    }\n  }\n}\n\n//div.wrap-all-boxes.tabled-display.new-dashboard > div.practioner-dash-wrap > div.pre-work.common-section-wrap.col-sm-3 > div > div:nth-child(3) > div > div > div.ibox-content.product-box > div.product-imitation.ng-binding > a, div.wrap-all-boxes.tabled-display.new-dashboard > div.practioner-dash-wrap > div.session.common-section-wrap.col-sm-3 > div > div:nth-child(5) > div > div > div.ibox-content.product-box > div.product-imitation.ng-binding > a, div.wrap-all-boxes.tabled-display.new-dashboard > div.practioner-dash-wrap > div.session.common-section-wrap.col-sm-3 > div > div:nth-child(6) > div > div > div.ibox-content.product-box > div.product-imitation.ng-binding > a{\n//  color:#48ac51;\n//}\n\n/* feedback-large-icon*/\n\n.big-profile {\n\n  .profile_types {\n    background:url($assets+'/images/foursight-profile-types-lg.png') !important;\n    width:160px;\n    height: 80px;\n  }\n\n  .developer {\n    background-position:-680px -84px !important;\n  }\n  .accelerator {\n    background-position: -170px 0 !important; }\n\n  .analyst {\n    background-position: 0 -174px !important; }\n\n  .clarifier {\n    background-position: -345px -174px !important; }\n\n  .driver {\n    background-position: -334px 0 !important; }\n\n  .early-bird {\n    background-position: -338px -84px !important; }\n\n  .finisher {\n    background-position: -676px 0 !important; }\n\n  .hare {\n    background-position: -512px -174px !important; }\n\n  .idea-broker {\n    background-position: -506px 0 !important; }\n\n  .ideator {\n    background-position: 0 -84px !important; }\n\n  .implementer {\n    background-position: -170px -84px !important; }\n\n  .integrator {\n    background-position: -680px -196px !important;\n    margin-top: 0px;\n    height: 40px; }\n\n  .optimist {\n    background-position: -172px -174px !important; }\n\n  .realist {\n    background-position: -508px -84px !important; }\n\n  .theorist {\n    background-position: 0 0 !important; }\n}\n\n// Remove Download Option for Audio Files\nvideo::-internal-media-controls-download-button, audio::-internal-media-controls-download-button {\n  display:none;\n}\n\nvideo::-webkit-media-controls-enclosure, audio::-webkit-media-controls-enclosure {\n  overflow:hidden;\n}\n\nvideo::-webkit-media-controls-panel, audio::-webkit-media-controls-panel {\n  width: calc(100% + 30px); /* Adjust as needed */\n}\n\n.interactive-guide {\n  overflow: hidden;\n\n  .feedback {\n    box-shadow: 0px 0px 39px -5px $body-content-color;\n    margin: 0px !important;\n  }\n}\n\n.flipbook {\n  width: 100% !important;\n  margin-top: 60px;\n\n  .page-wrapper {\n    margin: 0 auto !important;\n  }\n\n  &-viewport {\n    overflow: hidden;\n    width: 100%;\n    height: 100%;\n\n    .container {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      margin: auto;\n    }\n\n    .flipbook {\n      width: 922px;\n      height: 600px;\n      left: -461px;\n      top: -300px;\n    }\n\n    .page {\n      width: 461px;\n      height: 600px;\n      background-color: white;\n      background-repeat: no-repeat;\n      background-size: 100% 100%;\n    }\n\n    .shadow {\n      -webkit-transition: -webkit-box-shadow 0.5s;\n      -moz-transition: -moz-box-shadow 0.5s;\n      -o-transition: -webkit-box-shadow 0.5s;\n      -ms-transition: -ms-box-shadow 0.5s;\n      -o-box-shadow: 0 0 20px $color-neutral-mid;\n      -ms-box-shadow: 0 0 20px $color-neutral-mid;\n      box-shadow: 0 0 20px $color-neutral-mid;\n    }\n  }\n\n  .page {\n    -ms-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n    -o-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n\n    img {\n      -webkit-touch-callout: none;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n      margin: 0;\n      max-width: 100%;\n    }\n  }\n\n  .feedback-footer audio {\n    vertical-align: bottom;\n    margin-top: 12px;\n    margin-bottom: 0px;\n  }\n\n  .f-score .col-xs-7 img {\n    width: 100%;\n  }\n\n  #f-implement img {\n    max-width: 100%;\n  }\n\n  .feedback-footer audio {\n    width: calc(100% - 165px);\n    min-width: 0px;\n  }\n\n  #f-zone .feedback-content p {\n    margin-top: 25%;\n  }\n\n  #congo .title-sm {\n    margin-top: 15%;\n  }\n  #f-implement .title-sm {\n    margin-bottom: 12%;\n  }\n  .feedback .custom-col {\n    width:23%;\n    margin: 1%;\n  }\n}\n\n.flip-control {\n  text-align: center;\n\n  a {\n    display: inline-block;\n    margin: 0px 5px;\n  }\n}\n\n@media only screen  and (min-width:1000px) and (max-width:1200px) {\n\n  .flipbook {\n\n    .col-xs-7 , .col-xs-5{\n      width:100%;\n    }\n\n    .title-sm {\n      font-size: 26px !important;\n    }\n\n    .feedback .title {\n      font-size: 40px;\n      line-height: 42px;\n    }\n  }\n}\n\n@media only screen  and (max-width:767px) {\n\n  .flipbook {\n\n    .title-sm {\n      font-size: 26px !important;\n    }\n\n    .feedback .title {\n      font-size: 40px;\n      line-height: 42px;\n    }\n  }\n}\n\n@media only screen  and (max-width:420px) {\n\n  .flipbook {\n\n    .col-xs-7 , .col-xs-5{\n      width:100%;\n    }\n\n    .feedback .custom-col {\n      width: 48%;\n      margin: 1%;\n    }\n\n    #think {\n      background-size: inherit !important;\n      background-position-y: 50% !important;\n    }\n\n    #f-profile {\n\n      .title-sm {\n        margin-bottom: 28%;\n      }\n    }\n  }\n}\n.circled-preference{\n  border: 2px solid;\n  border-radius: 65% 65%;\n  padding: 20px 0px;\n}\n}\n\n\n\n/* full-screen-style */\n\n#full-screen {\n  margin-left: 15px;\n  margin-right: 15px;\n}\n\na#exit-screen {\n  display: none;\n  position: absolute;\n  top: 20px;\n  right: 30px;\n  font-size: 18px;\n  color:#6c6c6c;\n}\n\n::ng-deep body.full-screen {\n\n  @media only screen and (max-width: 767px) and (orientation:portrait){\n    overflow: hidden;\n    position: fixed;\n  }\n\n  .feedback-page {\n    position: fixed;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 999999;\n    background: $color-light-type;\n    left: 0;\n    margin-top: 0px;\n    padding:0px;\n\n    @media only screen and (max-height:414px) and (orientation:landscape){\n      position:absolute;\n      overflow: hidden;\n      //-webkit-overflow-scrolling: touch;\n    }\n  }\n\n  .feedback-slider {\n    margin:0px;\n  }\n  a#exit-screen {\n    display: block;\n    z-index:99;\n  }\n\n  .feedback {\n    max-width: 100%;\n    top:0;\n    bottom:0;\n\n    // p {\n    //   font-size:36px;\n    // }\n\n    // ul li {\n    //   font-size: 36px;\n    // }\n  }\n\n  // #nav {\n  //   max-width: 100% !important;\n  //   bottom:0;\n  // }\n\n  // #Dots {\n  //   bottom: 0;\n  //   max-width: 100%;\n  //   padding-left: 34%;\n  // }\n\n  // #feed-banner .title {\n  //   font-size: 2em;\n  // }\n\n  // #great-mind .title-sm , .feedback .title-sm{\n  //   font-size: 1.5em;\n  // }\n\n  .custom-row {\n    overflow: hidden;\n    width: 100%;\n  }\n\n  // .feedback .custom-col {\n  //   float:left;\n  //   margin: 1%;\n  //   width:23%;\n\n  //   img {\n  //     max-width: 80%;\n  //     width:100%;\n  //   }\n\n  //   p {\n  //     font-size:30px;\n  //   }\n  // }\n\n  // #f-bulb {\n  //   background-size: 432px 467px !important;\n\n  //   .title {\n  //     font-size: 2em;\n  //     line-height: 80px;\n  //   }\n  // }\n\n  // #congo {\n\n  //   .feedback-content {\n  //     margin-top: 15%;\n  //   }\n  // }\n\n  // #f-profile {\n\n  //   .feedback-content {\n\n  //     p {\n  //       margin-top: 5%;\n\n  //       img {\n  //         max-width: 50%;\n  //         width: 100%;\n  //       }\n  //     }\n  //   }\n  // }\n\n  // .feedback-content {\n\n  //   .f-sight, .f-score {\n\n  //     img {\n  //       max-width: 80%;\n  //       width:100%;\n  //     }\n  //   }\n  // }\n\n  .owl-carousel{\n    .feedback-content {\n\n      .f-sight, .f-score {\n\n        img {\n          max-width: 150px;\n          width:100%;\n\n          @media only screen and (max-height: 414px) and (orientation:landscape) {\n            max-width:115px;\n          }\n\n        }\n      }\n    }\n  }\n\n  // #f-now {\n  //   .title-sm {\n  //     font-size: 2em;\n  //   }\n  // }\n}\n\n\n  ::ng-deep body.full-screen #owl-demo{\n    width: 90%;\n    margin-top: 35px;\n  }\n\n  @media only screen and (min-width:768px){\n    ::ng-deep body.full-screen #owl-demo{\n      margin-top: 60px;\n    }\n  }\n\n  @media only screen and (max-height:736px) and (orientation:portrait){\n    ::ng-deep body.full-screen #owl-demo {\n      /*width: 90%;*/\n      margin-top: 40px;\n    }\n  }\n\n  @media only screen and (max-height:414px) and (orientation:landscape){\n    ::ng-deep body.full-screen #owl-demo {\n      margin-top: 40px;\n      /*width: 100%;\n      margin-top: 0px;\n      -webkit-transform: scale(0.61);\n      -moz-transform: scale(0.61);\n      -ms-transform: scale(0.61);\n      -o-transform: scale(0.61);\n      transform: scale(0.61);\n      position: relative;\n      top: -70px;\n      margin-left: -75px;\n      width:90%;*/\n    }\n  }\n\n  @media only screen  and (max-width:767px) {\n  ::ng-deep body.full-screen  {\n    .feedback ul li {\n      font-size: 20px;\n    }\n\n    .feedback .custom-col p {\n      font-size: 16px;\n    }\n    a#exit-screen {\n      font-size: 16px;\n    }\n    .feedback p {\n      font-size: 16px;\n    }\n    .owl-carousel{\n      .feedback{\n        ul li {\n          font-size: 16px;\n        }\n        p{\n          font-size: 16px;\n        }\n        .custom-col{\n          float: none;\n        }\n      }\n      #f-bulb{\n        background-size: contain !important;\n      }\n    }\n  }\n}\n\n::ng-deep .work-well-slide{\n  h3{\n    font-size: 22px;\n  }\n\n  .title-sm{\n    margin-bottom: 50px !important;\n\n    @media(max-width: 767px){\n      margin-bottom: 25px !important;\n    }\n\n  }\n\n  .disabled{\n    height: 50px;\n    vertical-align: middle;\n    margin-top: 35px;\n    font-size: 28px;\n\n    @media(max-width: 767px){\n      margin: 0px;\n    }\n  }\n}\n\n\n@media (min-width: 680px){\n  .new-dashboard .col-sm-3 {\n    max-width: 180px;\n  }\n}\n\n@media only screen  and (max-width:767px) {\n  ::ng-deep .feedback-page {\n\n    .col-xs-7 , .col-xs-5{\n      width:100%;\n    }\n\n    .feedback-content {\n      padding: 20px 20px 0;\n    }\n\n    #prevtBtn, #nextBtn {\n      font-size: 25px !important;\n      bottom:8px;\n    }\n\n    #prevtBtn {\n      margin-right: 30px !important\n    }\n\n    #nextBtn  {\n      right:4px;\n    }\n\n    // .feedback-footer audio {\n    //   width: 100%;\n    // }\n\n    div#Dots {\n      padding-left:16%;\n\n      .Dot {\n        width:5px;\n        height: 5px;\n        margin:3px;\n      }\n    }\n\n    a#exit-screen {\n      top: 5px;\n      right: 5px;\n    }\n  }\n}\n\n\n\n@media only screen and (max-height: 414px) and (orientation:landscape) {\n  ::ng-deep .feedback-page {\n    .col-xs-7{\n      width:50% !important;\n    }\n    .col-xs-5{\n      width:50% !important;\n    }\n  }\n\n  ::ng-deep .work-well-slide .center-block {\n    text-align: center;\n  }\n\n  ::ng-deep .work-well-slide .col-sm-2, .work-well-slide .col-sm-5 {\n    display: inline-block;\n    vertical-align: middle;\n    width: 25%;\n  }\n\n  ::ng-deep body.full-screen{\n    width:100%;\n    overflow: hidden;\n\n    #owl-demo .item{\n      min-height: 260px !important;\n    }\n\n    #owl-demo #think.item{\n      background-size: 60% auto !important;\n      background-position: center center !important;\n    }\n\n    #page-wrapper {\n      min-height: 414px;\n    }\n\n    .feedback p {\n      font-size: 12px !important;\n    }\n\n    .owl-carousel{\n      .title{\n        font-size: 25px !important;\n        line-height: 1.1 !important;\n      }\n\n      .feedback{\n        .title-sm{\n          font-size: 15px !important;\n          margin-bottom: 5px;\n        }\n\n        .f-sight{\n          margin-top: 15px;\n        }\n\n        ul li {\n          font-size: 14px !important;\n        }\n        p{\n          font-size: 14px !important;\n        }\n\n        .custom-col{\n          width: 15%;\n        }\n\n        .feedback-footer{\n          max-height: 40px;\n          padding: 0px 5px;\n\n          .author-logo{\n            max-width: 40px;\n          }\n\n          .feedback-player{\n            padding: 0px 5px;\n            max-height: 40px;\n\n            audio{\n              height: 40px;\n              margin-bottom: 0px;\n            }\n          }\n        }\n      }\n\n      #f-profile #chartarea{\n        -webkit-transform:scale(0.58);\n        -moz-transform:scale(0.58);\n        -ms-transform:scale(0.58);\n        -o-transform:scale(0.58);\n        transform:scale(0.58);\n        margin-top: -40px;\n        width: 100%;\n      }\n\n      #clar-result #chartarea,\n      #w-ideat-result #chartarea,\n      #w-develop-result #chartarea,\n      #w-impl-result #chartarea{\n        -webkit-transform:scale(0.9);\n        -moz-transform:scale(0.9);\n        -ms-transform:scale(0.9);\n        -o-transform:scale(0.9);\n        transform:scale(0.9);\n      }\n\n      #f-implement{\n        img{\n          max-width: 200px;\n        }\n      }\n    }\n  }\n}\n\n::ng-deep .feedback-page {\n    img {\n      max-width: 100%;\n    }\n\n    .feedback .custom-col {\n      width:23%;\n      margin: 1%;\n\n      @media(max-width:767px){\n        width:20%;\n        max-width: 122px !important;\n        display: inline-block;\n        float: none;\n      }\n\n      @media(max-width:599px){\n        width:33%;\n        max-width: 105px !important;\n\n        ::ng-deep body.mini-navbar &{\n          width:39%;\n        }\n      }\n    }\n\n    .feedback{\n      @media(max-width:767px){\n        .custom-row {\n          margin: 0 auto;\n          display: inline-block;\n          text-align: center;\n          width: 100%;\n        }\n        .custom-col{\n          &:nth-child(3){\n            clear:both;\n          }\n        }\n      }\n    }\n\n    .c-profile img {\n      max-width: 300px;\n    }\n}\n\n\n::ng-deep .feedback {\n  max-width:980px;\n  margin:auto;\n  right:0;\n  text-align:left !important;\n  font-family: $muso-300;\n  background:$color-light-type;\n\n  .title {\n    font-size: 60px;\n    margin: 0px;\n    font-weight:600;\n    font-family: $muso-700;\n  }\n\n  .title-sm {\n    font-size: 40px;\n\n    @media(max-width:991px){\n        font-size: 30px;\n    }\n\n    @media(max-width:800px){\n        font-size: 27px;\n    }\n\n    margin: 0px 0 10px;\n    font-weight:600;\n    font-family: $muso-300;\n  }\n\n  .custom-col {\n    float:left;\n    margin:10px;\n  }\n\n  p {\n    font-size: 18px;\n  }\n\n  ul {\n    padding:0 0 0 22px;\n    margin:0px;\n\n    li\n    {\n      font-size:18px;\n\n      @media(max-width:767px){\n        font-size: 15px;\n\n        body.mini-navbar &{\n          font-size: 14px;\n        }\n      }\n\n    }\n  }\n}\n\n@media only screen  and (max-width:767px) {\n\n  ::ng-deep .feedback-page {\n\n    .title-sm {\n      font-size: 20px !important;\n      margin-bottom: 25px;\n    }\n\n    .feedback .title {\n      font-size: 40px;\n      line-height: 42px !important;\n    }\n  }\n\n  body.full-screen  {\n\n    .owl-carousel{\n      .feedback .title-sm {\n        font-size: 20px !important;\n      }\n      .title {\n        font-size: 40px;\n        line-height: 42px !important;\n      }\n    }\n  }\n}\n\n@media only screen and (max-height: 736px) and (orientation:portrait) {\n  body.full-screen{\n    #owl-demo{\n      .item{\n        min-height: 430px;\n      }\n    }\n\n    .owl-carousel{\n      .feedback{\n        .title-sm{\n          margin-bottom: 10px !important;\n          font-size: 18px !important;\n        }\n        .custom-col{\n          max-width: 98px !important;\n        }\n        .title{\n          font-size: 35px !important;\n          line-height: 1.1 !important;\n        }\n        ul li {\n          font-size: 14px !important;\n        }\n        p{\n          font-size: 14px !important;\n          margin-bottom: 0px;\n        }\n\n        .fs-logo-feedback{\n          img{\n            max-width: 250px;\n          }\n        }\n        .center-block{\n          -webkit-transform: scale(0.8);\n          -moz-transform: scale(0.8);\n          -ms-transform: scale(0.8);\n          -o-transform: scale(0.8);\n          transform: scale(0.8);\n          margin-top: -15px;\n        }\n      }\n      #f-implement1 .profile-description{\n        max-height: 255px;\n      }\n    }\n\n  }\n}\n\n@media print{\n  \n  @page {size: letter landscape; }\n  body{width:100%;\n    height:100%;\n    -webkit-transform: rotate(-90deg); \n    -moz-transform:rotate(-90deg);\n    max-height:100%;\n    max-width:100%\n  }\n\n  ::ng-deep body{\n      width:100% !important;\n  }\n\n  ::ng-deephtml{\n      width:100% !important;\n  }\n\n  ::ng-deepbody.fs-skin #wrapper{\n    overflow:visible !important;\n  }\n\n  ::ng-deep .cig-parent-wrapper{\n    #owl-demo{\n      max-width: 100% !important;\n    }\n\n    .owl-carousel .owl-wrapper-outer{\n      overflow: visible !important;\n    }\n    .owl-item{\n      float:none !important;\n      width:100% !important;\n      min-height:100% !important;\n      // transform: rotate(90deg) !important;\n      clear: both;\n      page-break-before: always !important;\n      //page-break-after: always !important;\n      display:block !important;\n      transform:translateY(20%) !important;\n    }\n    .owl-carousel .owl-wrapper{\n      page-break-inside: always !important;\n      float:none !important;\n    }\n    .owl-carousel .owl-wrapper, .owl-carousel .owl-item{\n      width:100% !important;\n      white-space: normal !important;\n      visibility: visible !important;\n      opacity:1 !important;\n      float:none !important;\n    }\n    #feed-banner{\n      background-image: url('https://assets.foursightonline.com/app/images/feed-banner.png') !important;\n    }\n    #great-mind{\n      background-image: url('https://assets.foursightonline.com/app/images/2nd-page.png') !important;\n    }\n    #think{\n      background-image: url('https://assets.foursightonline.com/app/images/think-pref.png') !important;\n    }\n    #f-bulb{\n      background-image: url('https://assets.foursightonline.com/app/images/feed-bulb.png') !important;\n    }\n    #f-now{\n      background-image: url('https://assets.foursightonline.com/app/images/f-now.png') !important;\n    }\n    #f-end{\n      background-image: url('https://assets.foursightonline.com/app/images/f-end.png') !important;\n    }\n    .feedback-footer{\n      display:none !important;\n    }\n    .owl-controls{\n      display:none !important;\n    }\n  }\n\n  ::ng-deep body.fs-skin #hubspot-messages-iframe-container.widget-align-right{\n    display:none !important;\n  }\n}\n\n\n::ng-deep.translate-btn {\n    position: absolute;\n    bottom: 18px;\n    right: 11%;\n}\n::ng-deep.translate-text{\n  font-size: 16px !important;\n  max-width: 980px;\n  margin: 20px auto 0 auto;\n  .well{\n    max-height: 180px;\n    overflow-y: auto;\n  }\n}\n\n\n\n::ng-deep.feedback-player {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n::ng-deep.cig-parent-wrapper {\n  .owl-buttons {\n      position: absolute;\n      right: 15px;\n      top: auto;\n      bottom: 35px;\n      @media only screen and (max-width: 991px) {\n        bottom: -13px;\n      }\n      @media only screen and (max-width: 767px) {\n        bottom: 3px;\n      }\n      @media only screen and (max-width: 575px) {\n        position: static;\n      }\n  }\n}\n\n::ng-deep.translate-btn {\n    position: absolute;\n    bottom: 55px;\n    right: 110px;\n    background: transparent !important;\n    border: transparent !important;\n    color: #6c6c6c !important;\n    &:active {\n      box-shadow: none !important;\n    }\n    i::after {\n      content: \"\";\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      display: block;\n  }\n\n    @media only screen and (max-width: 991px) {\n      bottom: 29px;\n    }\n    @media only screen and (max-width: 575px) {\n      right: 10px;\n    }\n    \n    \n}\n\n::ng-deep.translate-btn.translate-btn2 {\n    right: 158px;\n}\n\n::ng-deep.feedback-footer {\n  audio + img + img {\n    \n      @media only screen and (max-width: 991px) {\n        display: none;\n      }\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
